import PageHeader from "../components/PageHeader";
import { Construction } from "lucide-react";
import * as Icons from "lucide-react";

export default function Placeholder({ title, subtitle, icon = "Construction", features = [], testId }) {
  const HeaderIcon = Icons[icon] || Construction;
  return (
    <div data-testid={testId || "placeholder-page"}>
      <PageHeader title={title} subtitle={subtitle} icon={HeaderIcon} />

      <div className="pgp-card p-10 flex flex-col items-center text-center pgp-fade-up">
        <div className="h-16 w-16 rounded-2xl bg-slate-800/70 border border-slate-700 flex items-center justify-center mb-5">
          <Construction className="h-8 w-8 text-amber-400" />
        </div>
        <h3 className="text-lg font-head font-semibold text-slate-100">Sezione in arrivo</h3>
        <p className="text-sm text-slate-400 mt-2 max-w-md">
          Questa sezione fa parte dell'architettura di PatroGestPro ed è già collegata a ruoli e permessi.
          Le funzionalità operative verranno abilitate nelle prossime fasi.
        </p>

        {features.length > 0 && (
          <div className="mt-8 w-full max-w-xl text-left">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-mono mb-3">Funzionalità previste</div>
            <ul className="grid sm:grid-cols-2 gap-2">
              {features.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-300 bg-slate-800/40 border border-slate-800 rounded-lg px-3 py-2">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
